import API from '@/assets/libraries/API_Requests';

export async function getShowInventoryInfo({ show_id, include_firework_data = true }) {
	try {
		const response = await API.Call('GET', `${API.COBRA_PORTAL_API_URL}/inventory/order/show/${show_id}?include_firework_data=${include_firework_data}`, {});

		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}

export async function updateShowDate(show_order_id, show_date) {
	try {
		const response = await API.Call('PUT', `${API.COBRA_PORTAL_API_URL}/inventory/order/show/show_date/${show_order_id}`, show_date);

		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}

export async function updateBudget(show_order_id, show_budget) {
	try {
		const response = await API.Call('PUT', `${API.COBRA_PORTAL_API_URL}/inventory/order/show/budget/${show_order_id}`, { budget: show_budget });

		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}

export async function updateShowOrderState(show_order_id, show_order_state) {
	try {
		const response = await API.Call('PUT', `${API.COBRA_PORTAL_API_URL}/inventory/order/shows/${show_order_id}`, show_order_state);

		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}

export async function syncInventoryItem(show_order_id, inventory_id, quantity) {
	try {
		const response = await API.Call('PUT', `${API.COBRA_PORTAL_API_URL}/inventory/order/shows/${show_order_id}/items/${inventory_id}`, { quantity });

		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}

export async function syncManyInventoryItems(show_order_id, items) {
	try {
		const response = await API.Call('PUT', `${API.COBRA_PORTAL_API_URL}/inventory/order/shows/${show_order_id}/items`, { items });

		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}
